import { CreateProcedureForm, CreateProcedure, EMedicalReferralType } from '@project/view-models';

export function formatMedicalReferralPayload(
  formValue: any,
  procedures: any[],
  procedureType: 'APAC' | 'SADT',
): CreateProcedureForm {
  const isApac = procedureType === 'APAC';

  const formattedProcedures: CreateProcedure[] = procedures.map((proc) => ({
    id: proc.id,
    code: proc.code,
    description: proc.description,
    quantity: proc.quantity,
    source_procedure_combo_id: proc.protocolId,
    is_apac: isApac,
    is_sadt: !isApac,
    temp: false,
  }));

  return {
    patient_id: formValue.patient_id,
    requisition_id: formValue.requisition_id,
    diagnosis_description: formValue.diagnosis_description,
    primary_cid_id: formValue.primary_cid_id,
    note: formValue.note,
    medical_referral_type: EMedicalReferralType.Exam,
    procedures: formattedProcedures,
  };
}
